import { MenubarItem } from "./menubarItem";
import { Navigation } from "./navigation";
import { PopupMenu } from "./popupMenu";
import { PopupMenuItem } from "./popupMenuItem";

export function isPopupMenuItem(item : IMenuItem): item is PopupMenuItem {
    return item.type === "PopupMenuItem";
}

export type MenuItemType = "PopupMenuItem" | "MenuBarItem";

export interface IMenuItem {
    type: MenuItemType;
    parent?: MenubarItem | PopupMenuItem;
    domNode: HTMLElement;
    menu: PopupMenu | Navigation;
    hasHover: boolean;
    hasFocus: boolean;
    SetExpanded: (isExpanded: boolean) => void;
}

export function isNavigationMenuItemParent(item : IMenuItemParent): item is Navigation {
    return item.type === "Navigation";
}

export type MenuItemParentType = "Navigation" | "PopUpMenu";

export interface IMenuItemParent {
    type: MenuItemParentType;
    Close: (force: boolean) => void;
}
